import React from 'react';

// Palette cohérente avec ton design
const COLORS = [
  '#0C5B6D', // bleu principal
  '#FB923C', // orange
  '#F1F6FC', // gris très clair
  '#083f4c', // bleu foncé
  '#3B82F6', // bleu clair
  '#F59E42', // orange doux
  '#A7C7DC', // bleu pastel
  '#F3F4F6', // gris clair
  '#2563EB', // bleu moyen
  '#FDE68A', // jaune pastel
  '#10B981', // vert émeraude
  '#F87171', // rouge doux
  '#6366F1', // violet doux
  '#F472B6', // rose doux
  '#34D399', // vert menthe
  '#FBBF24', // jaune doré
  '#60A5FA', // bleu ciel
  '#A78BFA', // violet pastel
  '#FCA5A5', // rose clair
  '#D1D5DB', // gris perle
];

// Détermine la couleur à partir du nom
function getColorFromName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % COLORS.length;
  return COLORS[idx];
}

// Contraste texte/fond
function getContrastYIQ(hexcolor) {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0,2),16);
  const g = parseInt(hexcolor.substr(2,2),16);
  const b = parseInt(hexcolor.substr(4,2),16);
  const yiq = ((r*299)+(g*587)+(b*114))/1000;
  return yiq >= 128 ? '#222' : '#fff';
}

const AvatarCircle = ({ name, size = 40 }) => {
  const bgColor = getColorFromName(name || '');
  const textColor = getContrastYIQ(bgColor);
  const firstLetter = (name || '?').charAt(0).toUpperCase();

  return (
    <div
      style={{
        background: bgColor,
        color: textColor,
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'normal',
        fontSize: size * 0.6,
        userSelect: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      }}
      title={name}
    >
      {firstLetter}
    </div>
  );
};

export default AvatarCircle;